import { useEffect, useState } from 'react';
import { Bell } from 'lucide-react';
import { supabase } from '@/lib/supabase';
import NotificationPanel from './NotificationPanel';

/** Header'da çan ikonu + okunmamış bildirim sayım rozeti.
 *  Realtime subscription ile yeni bildirim anında badge'i güncelliyor.
 *  Tıklayınca NotificationPanel açılır.
 */
export default function NotificationBell() {
  const [count, setCount] = useState<number>(0);
  const [hasCritical, setHasCritical] = useState<boolean>(false);
  const [open, setOpen] = useState(false);

  async function reloadCount() {
    const { data } = await supabase
      .from('v_unread_notifications')
      .select('id, severity');
    const rows = (data ?? []) as Array<{ id: number; severity: string }>;
    setCount(rows.length);
    setHasCritical(rows.some((r) => r.severity === 'critical'));
  }

  useEffect(() => {
    reloadCount();

    // Realtime subscription — yeni notification veya read_at güncellemesi
    const channel = supabase
      .channel('notifications-bell')
      .on(
        'postgres_changes',
        { event: '*', schema: 'public', table: 'notifications' },
        () => reloadCount()
      )
      .subscribe();

    return () => {
      supabase.removeChannel(channel);
    };
  }, []);

  return (
    <>
      <button
        onClick={() => setOpen(true)}
        className="relative inline-flex items-center text-slate-600 hover:text-slate-900"
        aria-label={`${count} okunmamış bildirim`}
        title={`${count} okunmamış bildirim`}
      >
        <Bell className={`w-5 h-5 ${hasCritical ? 'text-red-600' : ''}`} />
        {count > 0 && (
          <span
            className={
              'absolute -top-1.5 -right-1.5 min-w-[16px] h-4 px-1 rounded-full text-[10px] font-bold leading-4 text-white text-center ' +
              (hasCritical ? 'bg-red-600' : 'bg-amber-500')
            }
          >
            {count > 99 ? '99+' : count}
          </span>
        )}
      </button>

      <NotificationPanel
        open={open}
        onClose={() => {
          setOpen(false);
          reloadCount();
        }}
      />
    </>
  );
}
